import React, { useState, useCallback } from "react";
// import PropTypes from 'prop-types';

import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";

const Transcription = (props) => {
  const { header, data, customerInvoice, updateInvoice, classes } = props;
  const serviceLabel = data.vat ? "VAT" : "Service Charges";
  let { id } = useParams();

  const [isEdit, setIsEdit] = useState(true);
  const toEditHandler = () => {
    setIsEdit(false);
  };

  const formValue = {
    _id: data?._id,
    totalAmount: data?.total,
    discounts: data?.discounts,
    subTotal: data?.subTotal?.toFixed(2),
    serviceChargePercent: data?.adminPercent,
    invTotal: data?.invTotal?.toFixed(2),
    advancePayment: data?.advancePayment,
  };

  const { register, handleSubmit, watch } = useForm({
    mode: "onChange",
    defaultValues: formValue,
  });

  const discountsWatch = watch("discounts");

  const subTotalAmount = useCallback(() => {
    let total = 0;
    let discount = parseFloat(discountsWatch) || 0;
    total = data?.total - discount;
    return total;
  }, [data.total, discountsWatch]);

  const totalPercentage = useCallback(() => {
    let total = 0;
    total = parseFloat(
      (subTotalAmount() * formValue.serviceChargePercent) / 100,
    );
    return total;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subTotalAmount]);

  const invTotal = useCallback(() => {
    let invTotal = 0.0;
    invTotal = totalPercentage() + subTotalAmount();
    return invTotal.toFixed(2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.total, subTotalAmount]);

  const dueTotal = useCallback(() => {
    var advPayment = 0;
    var total = 0;

    advPayment = formValue.advancePayment || 0.0;
    total = invTotal() - advPayment;
    return total;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invTotal]);

  const onSubmit = async (data) => {
    // console.log(data)
    try {
      await updateInvoice(data, id);
      await setIsEdit(true);
    } catch (error) {
      console.log(error);
      await setIsEdit(false);
    }
  };

  return (
    <>
      <input
        type="hidden"
        value={formValue._id}
        ref={register}
        name="_id"
        readOnly
      />
      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={header} colSpan="3">
                Description
              </TableCell>
              <TableCell className={header} align="right">
                Hours
              </TableCell>
              <TableCell className={header} align="right">
                Mins
              </TableCell>
              <TableCell className={header} align="right">
                Minimum rate (£)
              </TableCell>
              <TableCell className={header} align="right">
                Amount (£)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" colSpan="2">
                Status
              </TableCell>
              <TableCell align="right">{data.status}</TableCell>
              <TableCell align="right">
                {data.tMinDuration >= 60 ? 1 : 0}
              </TableCell>
              <TableCell align="right">
                {data.tMinDuration < 60 ? data.tMinDuration : 0}
              </TableCell>
              <TableCell align="right">{data.minRate.toFixed(2)}</TableCell>
              <TableCell align="right">{data.minRate.toFixed(2)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row" colSpan="2">
                Transcription cost per min <br /> (charged over 60mins)
              </TableCell>
              <TableCell align="right">Additional duration</TableCell>
              <TableCell align="right">
                {data.additionalDuration >= 60 ? 1 : 0}
              </TableCell>
              <TableCell align="right">
                {data.additionalDuration < 60 ? data.additionalDuration : 0}
              </TableCell>
              <TableCell align="right">{data.costPerMin.toFixed(2)}</TableCell>
              <TableCell align="right">{data.amount.toFixed(2)}</TableCell>
            </TableRow>

            {/* CHANGES START HERE */}

            <TableRow>
              <TableCell component="th" scope="row" colSpan="2">
                File format
              </TableCell>
              <TableCell align="right">Video</TableCell>
              <TableCell align="right" colSpan={4}></TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row" colSpan="6">
                Gross Amount
              </TableCell>
              <TableCell align="right">
                {(data.grossAmount || data.amount || 0).toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row" colSpan="6">
                VAT Amount
              </TableCell>
              <TableCell align="right">
                {(data.vatAmount || 0).toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row" colSpan="6">
                <strong>Total Amount</strong>
              </TableCell>
              <TableCell align="right">
                {(data.total || 0).toFixed(2)}
              </TableCell>
            </TableRow>

            {/* CHANGES END HERE */}

            {/* <TableRow>
              <TableCell component="th" scope="row" colSpan="2">
                File format
              </TableCell>
              <TableCell align="right">Video</TableCell>
              <TableCell align="right" colSpan={3}>
                <strong>Total</strong>
              </TableCell>
              <TableCell align="right">{data.total.toFixed(2)}</TableCell>
            </TableRow> */}
            {customerInvoice && (
              <>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Discounts
                  </TableCell>
                  <TableCell align="right" colSpan={6}>
                    {/* {data.discounts.toFixed(2)} */}
                    {isEdit ? (
                      <IconButton
                        aria-label="edit"
                        style={{ marginRight: "16px" }}
                        size="small"
                        onClick={toEditHandler}
                      >
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="edit"
                        style={{ marginRight: "16px", marginTop: "12px" }}
                        size="small"
                        onClick={handleSubmit(onSubmit)}
                        color="primary"
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    )}
                    {isEdit ? (
                      data.discounts.toFixed(2)
                    ) : (
                      <TextField
                        label="Amount"
                        size="small"
                        fullWidth
                        variant="filled"
                        type="number"
                        name="discounts"
                        inputRef={register}
                        defaultValue={data?.discounts || 0}
                        style={{ width: "80px" }}
                      />
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <strong>Sub Total</strong>
                  </TableCell>
                  <TableCell align="right" colSpan={6}>
                    {/* {data.subTotal.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="subTotal"
                      ref={register}
                      value={subTotalAmount().toFixed(2)}
                      readOnly
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {serviceLabel}
                  </TableCell>
                  <TableCell align="right" colSpan={5}>
                    @{data.adminPercent}%
                  </TableCell>
                  <TableCell align="right">
                    {/* {data.adminCharges.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="adminCharges"
                      ref={register}
                      value={totalPercentage().toFixed(2)}
                      readOnly
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    <strong>Invoice Total</strong>
                  </TableCell>
                  <TableCell align="right" colSpan={6}>
                    {/* {data.advancePayment.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="invTotal"
                      ref={register}
                      value={invTotal()}
                      readOnly
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    Advance / Others
                  </TableCell>
                  <TableCell align="right" colSpan={6}>
                    {data.advancePayment.toFixed(2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <strong>Amount Due</strong>
                  </TableCell>
                  <TableCell align="right" colSpan={6}>
                    {/* {data.grossTotal.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="grossTotal"
                      ref={register}
                      value={dueTotal().toFixed(2)}
                      readOnly
                    />
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Transcription;
